<template>
  <div>
    <div class="operation">
      <!-- <el-button type="primary">
                批量下载作品
      </el-button>-->
      <el-button type="primary" @click="excel">{{$ct('export')}}</el-button>
    </div>
    <el-table :data="data" v-loading="loading" style="min-height:200px">
      <el-table-column :label="$ct('num')" type="index" width="60"></el-table-column>
      <el-table-column :label="$ct('workName')" prop="name"></el-table-column>
      <el-table-column :label="$ct('teacherScore')" prop="score" width="140">
        <template slot-scope="s">
          <div v-if="s.row.score || s.row.score ===0" class="pointer">
            <el-rate
              v-model="s.row.rate"
              disabled
              :show-score="false"
              text-color="#ff9900"
              @click.native="showScore({data: s, type: 'teacher'})"
              :show-text="false"
            ></el-rate>
          </div>
          <span v-else>-</span>
          <!-- <a href="javascript:void(0)" @click="score(s)">
                        {{s.row.score}}
          </a>-->
        </template>
      </el-table-column>
      <el-table-column :label="$ct('selfScore')" width="140">
        <template slot-scope="s">
          <div v-if="s.row.selfRate || s.row.selfRate ===0" class="pointer">
            <el-rate
              v-model="s.row.selfRate"
              disabled
              :show-score="false"
              text-color="#ff9900"
              @click.native="showScore({data: s, type: 'student'})"
              :show-text="false"
            ></el-rate>
          </div>
          <span v-else>-</span>
          <!-- <a href="javascript:void(0)" @click="score(s)">
            {{s.row.score}}
          </a>-->
        </template>
      </el-table-column>
      <el-table-column :label="$ct('mutualScore')" width="140">
        <template slot-scope="s">
          <div v-if="s.row.mutualScore || s.row.mutualScore ===0" class="pointer">
            <el-rate
              v-model="s.row.mutualScore"
              disabled
              :show-score="false"
              text-color="#ff9900"
              @click.native="mutualEvaluation(s)"
              :show-text="false"
            ></el-rate>
          </div>
          <span v-else>-</span>
          <!-- <a href="javascript:void(0)" @click="score(s)">
            {{s.row.score}}
          </a>-->
        </template>
      </el-table-column>
      <el-table-column :label="$ct('workStatus')" prop="updated_at">
        <template slot-scope="s">
          <span>{{statusFilter(s.row.status)}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$ct('updatedTime')" prop="updated_at">
        <template slot-scope="s">
          <span>{{s.row.updated_at | dateFilter}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$ct('studentName')" prop="username"></el-table-column>
      <el-table-column :label="$ct('className')" prop="class_name"></el-table-column>
      <el-table-column :label="$ct('scorer')" prop="raters_name"></el-table-column>
      <el-table-column :label="$ct('operation')" fixed="right" width="360">
        <template slot-scope="s">
          <div>
            <el-button type="primary" size="mini" @click="score(s)">{{$ct('score')}}</el-button>
            <el-button type="primary" :disabled="s.row.type === 7" size="mini" @click="checkWork(s)">{{$ct('viewWork')}}</el-button>
            <el-button type="primary" size="mini" @click="download(s)">{{$ct('download')}}</el-button>
            <el-button type="primary" size="mini" @click="share(s)">{{$ct('share')}}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="showModal" :title="$ct('share')" width="380px">
      <qrcode-form :url="modalLink"/>
    </el-dialog>
    <el-dialog :visible.sync="showMutualEvaluation" :title="$ct('shortMutualScore')" width="500px">
      <el-table :data="workMutualData" height="250" width="100%">
        <el-table-column prop="username" :label="$ct('name')"></el-table-column>
        <el-table-column :label="$ct('score')">
          <template slot-scope="s">
            <div v-if="s.row.score || s.row.score ===0" class="pointer">
              <el-rate
                v-model="s.row.score"
                disabled
                :show-score="false"
                text-color="#ff9900"
                :show-text="false"
              ></el-rate>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" :label="$ct('scoreTime')"></el-table-column>
      </el-table>
    </el-dialog>
    <el-pagination
      style="text-align:center;padding-top:20px"
      background=""
      layout="prev, pager, next,total, jumper"
      :total="total"
      :current-page.sync="page"
      :page-size="15"
      @current-change="pageChange"
    ></el-pagination>
  </div>
</template>

<style lang="scss" scoped>
a:hover {
  text-decoration: underline;
}
.heart {
  text-align: left;
  &:before {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 3px;
    margin-top: -1px;
    background: url('./img/heart.png') no-repeat;
    background-size: 100%;
    vertical-align: text-top;
  }
}
</style>

<script>
import { formatDate, funDownload, downloadFromQiniu, workScoreFilter, openLink } from '@/utils/utils'
import QrcodeForm from './qrcodeForm'

export default {
  components: {
    QrcodeForm
  },
  props: {
    data: Array,
    loading: Boolean
  },
  data() {
    return {
      modalLink: '',
      showModal: false,
      showMutualEvaluation: false,
      workMutualData: []
    }
  },
  computed: {
    page: {
      get() {
        return this.$store.state.workManage.page
      },
      set(page) {
        this.$store.commit('setState', {
          module: 'workManage',
          key: 'page',
          value: page
        })
        this.$emit('getData')
      }
    },
    total() {
      return this.$store.state.workManage.total
    }
  },
  filters: {
    dateFilter(date) {
      return formatDate(date)
    }
  },
  methods: {
    toolTypeFilter(type) {
      if (type === 0 || type === 1 || type === 4 || type === 6) {
        return this.$ct('ide')
      } else if (type === 5) {
        return this.$ct('box')
      } else if (type === 7) {
        return this.$ct('wood')
      }
    },
    statusFilter(status) {
      switch (status) {
        case 1:
          return this.$ct('unpublished')
        case -99:
          return this.$ct('deleted')
        case 100:
          return this.$ct('published')
        case -100:
          return this.$ct('destroyed')
      }
    },
    score(s) {
      this.$emit('score', { data: s, type: 'teacher' })
    },
    async checkWork(s) {
      const type = s.row.type
      const data = {
        id: s.row.id,
        type: 3
      }
      if (type === 1 || type === 4 || type === 6 || type === 0) {
        const newPage = window.open()
        const res = await this.$store.dispatch('bcmEncode', data)
        await this.$store.dispatch('getLoginStatus')
        if (res.status < 400) {
          const code = res.data.code
          openLink(CONFIG.ide + '?code=' + code + '&pid=V-OVJirH', newPage)
        };
      } else if (type === 5) {
        const newPage = window.open()
        const res = await this.$store.dispatch('bcmEncode', data)
        await this.$store.dispatch('getLoginStatus')
        if (res.status < 400) {
          const code = res.data.code
          openLink(`${CONFIG.box}?code=${code}&pid=V-OVJirH`, newPage)
        };
      }
    },
    async download(s) {
      const url = s.row.latest_work_url
      // python作品下载
      if (s.row.type === 7) {
        funDownload(s.row.content, s.row.name + '.py')
        return
      }
      downloadFromQiniu(url, s.row.name)
    },
    share(s) {
      // ide
      const type = s.row.type
      if (type === 1 || type === 4 || type === 6 || type === 0) {
        this.modalLink = `${CONFIG.ide}/old/we/${s.row.id}`
      } else if (type === 5) {
        this.modalLink = `${CONFIG.box}/w/${s.row.id}`
      }
      this.showModal = true
    },
    showScore(judgeInfo) {
      this.$emit('showScore', judgeInfo)
    },
    async mutualEvaluation (s) {
      this.workMutualData = []
      const res = await this.$store.dispatch('getWorkMutualInfo', s.row.id)
      if (res.status < 400) {
        for (const item of res.data) {
          item.score = workScoreFilter(item.score)
          item.updated_at = formatDate(item.updated_at)
          this.workMutualData.push(item)
        }
        this.showMutualEvaluation = true
      }
    },
    pageChange(page) {
      this.page = page
    },
    async excel() {
      const res = await this.$store.dispatch('workManageExcel')
      if (res.status < 400) {
        funDownload(res.data, this.$ct('excel.work'))
      }
    }
  }
}

</script>
